import React, {Component} from 'react';
import {Button} from 'react-weui';
import {connect} from 'react-redux';
import {ClassroomAudioArea, ClassroomTopVideo, ClassroomPPTSlide} from '.';
import {Medal} from '../../components/medal'
import EventBus from '../../utils/bus'

import '../../styles/classroom/ClassroomTopBar.css';
import { isChannelCPS } from '../../utils/cps';


class ClassroomTopBar extends Component {
    constructor() {
        super();
        this.state = {
            isLectureBegin: false,
            toAPPHeight: 0,
            isShowMedalModal: false,
            isRealSubscried: false,
            init: false
        }
        this.aToLocation = this.aToLocation.bind(this)
    }

    componentDidMount() {
        let {lecture, subscribed} = this.props;
        if (parseInt(Date.now() / 1000) > lecture.start_timestamp) {
            this.setState({isLectureBegin: true});
        } else {
            let leftTime = lecture.start_timestamp - parseInt(Date.now() / 1000);

            if (leftTime * 1000 > 1e8) {
                this.it = setTimeout(() => {
                    this.setState({isLectureBegin: true});
                }, 1e8);
            } else {
                this.it = setTimeout(() => {
                    this.setState({isLectureBegin: true});
                }, leftTime * 1000);
            }
        }

        try {
            EventBus.on('subscribed_retainInfo', (subscribed_retainIn) => {
                if (!subscribed && !subscribed_retainIn) {
                    this.setState({
                        isRealSubscried: false,
                        init: true
                    })
                } else {
                    this.setState({
                        isRealSubscried: true,
                        init: true
                    })   
                }
            }) 
        } catch (err) {
            console.log('subscribed_retainInfo eventBus error')
        }

        if (!window.localStorage.getItem('wk-classroom-app-clicked')) {
            this.appShow = setTimeout(() => {
                this.setState({
                    toAPPHeight: 44
                }, () => {
                    this.appHide = setTimeout(() => {
                        this.setState({
                            toAPPHeight: 0
                        })
                    }, 8000)
                })
            }, 2000);
        }
    }

    componentWillUnmount() {
        this.it && clearTimeout(this.it);
        this.appShow && clearTimeout(this.appShow);
        this.appHide && clearTimeout(this.appHide);
        EventBus.off('subscribed_retainInfo')
    }

    showTopVideo() {
        this.props.dispatch({
            type: 'CLASSROOM_SHOW_TOP_VIDEO'
        })
    }

    hideTopVideo() {
        this.props.dispatch({
            type: 'CLASSROOM_HIDE_TOP_VIDEO'
        })
        this.props.dispatch({
            type: 'ROBOT_HIDE_TOP'
        })
    }

    gotoLiveroom() {
        const {liveroom} = this.props
        window.location = `/liveroom/${liveroom.id}`
    }

    showFollowLiveroom() {
        const {qrcodes, liveroom} = this.props
        this.props.dispatch({
            type: 'SHOW_FOLLOW_LIVEROOM',
            payload: {
                qrcodes: qrcodes,
                liveroom: liveroom
            }
        })
    }

    gotoAppPage() {
        window.localStorage.setItem('wk-classroom-app-clicked', 1);
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: 'enter_app_from_classroom'
        });
        this.aToLocation('https://a.app.qq.com/o/simple.jsp?pkgname=com.lizhiweike');
    }

    aToLocation(url) {
        const goToApp = document.createElement('A')
        goToApp.href = url
        goToApp.id = 'goToApp'
        document.body.appendChild(goToApp)
        document.querySelector('#goToApp').click()
    }

    onClickMedal(type) {
        this.props.dispatch({type: 'CLASSROOM_SET_IS_SHOW_MEDAL_MODAL', payload: true})
        this.props.dispatch({type: 'CLASSROOM_SET_MEDAL_TYPE', payload: type})
    }

    toInvite() {
        let {lecture, accountId} = this.props
        if (!accountId) {
            accountId = ''
        }
        window.location = `/lecture/${lecture.id}/sharecard?account_id=${accountId}`;
    }

    render() {
        const {isLectureBegin, isRealSubscried, init} = this.state;
        const {lecture, liveroom, showTopVideo, role, options, subscribed,} = this.props
        const hasTopVideo = lecture.image_mode === 'video'
        const hasTopAudio = lecture.image_mode === 'audio'
        const hasTopPPT = options.ppt_open

        return <div className="classroom-header">
            <div className="classroom-top-bar ">
                { !isChannelCPS() && <div className="homepage-logo">
                    <img className="avatar circle" src={liveroom.small_avatar_url} alt=""
                         onClick={this.gotoLiveroom.bind(this)}/>
                    <span onClick={this.gotoLiveroom.bind(this)}>
                        <span className="name text-ellipsis">{liveroom.name.substring(0, 12)}</span>
                        {/* {liveroom.badges.map(item => (
                            <Medal
                                key={item}
                                type={item}
                                style={{width: '17px', height: 'auto', marginTop: '8px', float: 'none'}}
                                onClickMedal={e => this.onClickMedal(item)}
                            />
                        ))
                        } */}
					          </span>
                              {/* <p>{JSON.stringify(isRealSubscried)}</p> */}
                    {!(role.is_fans && isRealSubscried && !isChannelCPS()) && // 如果不是粉丝或者没有关注(大/小号之一),出现关注按钮
                    <span className="follow">
                        <Button type="primary" size="small" onClick={this.showFollowLiveroom.bind(this)}>关注</Button>
                    </span>}
                </div>}
                {(hasTopVideo || hasTopAudio || hasTopPPT) &&
                <div className="top-buttons top-right-btn">
                    {showTopVideo ?
                        <span className="toggle" onClick={this.hideTopVideo.bind(this)} style={{backgroundColor:'#e1e1e1'}}>
                                            {/* <i className="iconfont icon-shouqi"/> */}
                                            课件
							          </span>
                        :
                        <span className="toggle" onClick={this.showTopVideo.bind(this)}>
                                            {/* <i className="iconfont icon-shouqi-copy"/> */}
                                            课件
							          </span>
                    }
                </div>
                }
                { !isChannelCPS() && <div className="inviteBtn top-right-btn" onClick={() => this.toInvite()}>邀请</div> }
            </div>

            {(!hasTopVideo && !hasTopAudio && hasTopPPT) &&
            <ClassroomPPTSlide isLectureBegin={isLectureBegin}/>
            }
            {hasTopAudio &&
            <ClassroomAudioArea isLectureBegin={isLectureBegin}/>
            }
            {hasTopVideo &&
            <ClassroomTopVideo isLectureBegin={isLectureBegin}/>
            }

            {/* <div className="classroom-top-app" style={{height: this.state.toAPPHeight + 'px'}}
                onClick={() => this.gotoAppPage()}>
                <div className="classroom-top-app_text">
                    {role.is_lecturer ? 'APP讲课更稳定、音质更佳' : '使用APP全程回顾，永久回听'}
                </div>
                <div className="classroom-top-app_btn">前往APP</div>
            </div>             */}
        </div>
    }
}

export default connect((state) => ({
    liveroom: state.classroom.liveroom,
    lecture: state.classroom.lecture,
    showTopVideo: state.classroom.showTopVideo,
    role: state.classroom.role,
    options: state.classroom.options,
    qrcodes: state.classroom.qrcodes,
    ppt: state.ppt,
    subscribed: state.account.subscribed,
    accountId: state.account.id,
}))(ClassroomTopBar)




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomTopBar.js